import { FC } from 'react';

import { cn } from '@eluve/components';

const widthStyles = {
  full: 'w-full',
  half: 'w-1/2',
  third: 'w-1/3',
} as const;

const roundedStyles = {
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
} as const;

export interface ImageRendererProps {
  src: string;
  alt: string;
  width?: 'full' | 'half' | 'third';
  rounded?: 'sm' | 'md' | 'lg' | 'xl';
}

export const ImageRenderer: FC<ImageRendererProps> = ({
  src,
  alt,
  width,
  rounded,
}) => (
  <img
    src={src}
    alt={alt}
    className={cn(
      'h-auto shrink-0',
      width ? widthStyles[width] : undefined,
      rounded ? roundedStyles[rounded] : undefined,
    )}
  />
);
